// @ts-nocheck
import React, { useEffect, useState } from "react";
import "./style.less";
import clsx from "clsx";
import { ButtonComponent } from "../button";
import { ArrowIcon } from "../../../../resources/icons/header";
import { HotLink } from "../../hooks/api/use-homepage-info.hook";
import { Link } from "react-router-dom";
import { $api } from "../../api";
import { Text } from "../text";

interface SvgControllerComponentProps {
  item: HotLink;
  session: string;
}

const anotherStyle = [
  "sun-horizon.svg",
  "briefcase.svg",
  "group.svg",
  "file.svg",
  "handshake.svg",
];
export const SvgControllerComponent: React.FC<SvgControllerComponentProps> = (
  props,
) => {
  const [element, setElement] = useState<string | undefined>(undefined);
  const { item, session } = props;

  const style =
    "w-full p-2 justify-between flex gap-3 border border-hotlink-border bg-hotlink-bg text-primary-active";

  const setTarget = () => {
    const target = item.linkOpenType;
    if (target === "NEW_TAB") return "_blank";
    if (target === "CURRENT_TAB") return "_self";
    return "_blank";
  };

  useEffect(() => {
    const getImage = async () => {
      if (item.icon && item.icon.id) {
        try {
          const { data } = await $api.get(`/files/${item.icon.id}`);
          setElement(`${data}`);
        } catch (error) {
          console.error("Error fetching SVG:", error);
        }
      }
    };
    getImage();
  }, [item.icon]);

  if (!item.active) return null;
  return (
    <>
      {setTarget() === "_self" ? (
        <Link
          className={clsx(
            "activeSvg customSvg",
            item.icon && anotherStyle.includes(item.icon.name)
              ? "svg-controller-another"
              : "svg-controller",
          )}
          to={item.url}
        >
          <ButtonComponent className={style}>
            <div className={"flex gap-3 items-center"}>
              {item.icon && element && (
                <div
                  className={clsx("min-w-6 min-h-6 svg-controller-icon")}
                  dangerouslySetInnerHTML={{ __html: element }}
                />
              )}
              <span>{item["captionLang" + session] || ""}</span>
            </div>
            <span>
              <ArrowIcon className={"w-4 -rotate-90"} />
            </span>
          </ButtonComponent>
        </Link>
      ) : (
        <a
          className={clsx(
            item.icon && anotherStyle.includes(item.icon.name)
              ? "svg-controller-another"
              : "svg-controller",
          )}
          href={item.url || "#"}
          target={setTarget() || "_blank"}
        >
          <ButtonComponent className={style}>
            <div className={"flex gap-3 items-center"}>
              {item.icon && element && (
                <div
                  className={clsx("min-w-6 min-h-6 svg-controller-icon")}
                  dangerouslySetInnerHTML={{ __html: element }}
                />
              )}
              <Text weight={"500"} type={"body2"} as={"span"}>
                {item["captionLang" + session] || ""}
              </Text>
            </div>
            <span className={"svg-controller-icon"}>
              <ArrowIcon className={"w-4 -rotate-90"} />
            </span>
          </ButtonComponent>
        </a>
      )}
    </>
  );
};
